import React from 'react';
import './info.css';

function InfoHeadings() {
    return(
        <div className="headings-container"> 
            <h1> Mistä on kyse? </h1>
            <h2> Onko etusivusi jatkuvasti täynnä kiinnostavaa kontenttia? Törmäätkö jatkuvasti samojen käyttäjien videoihin? Näetkö entistä vähemmän tylsiä uutisia? </h2>
        </div>
    );
}

export default InfoHeadings;